import Vuex from 'vuex';
import axios from 'axios';
import config from '../config';
export default () => {
    return new Vuex.Store({
        state: {
            isLogin: false,
            userinfo: null,
            metaInfo: {
                title: '',
                title_en: '',
                keywords: '',
                keywords_en: '',
                description: '',
                description_en: '',
            },
            // 首页
            homeData: {
                banner: [],
                entertainment: [],
                entertainmentAll: [],
                art_licensing: [],
                art_licensingAll: [],
                goods: [],
                new_exhibition: [],
                new_exhibitionAll: [],
            },
            // 关于我们
            aboutData: {
                banner: [],
                bannerMobile: [],
                project: []
            },
            // 联系我们
            contactData: {
                banner: '',
                list: []
            },
            // 人才
            talentMenu: [],
            TMActiveIndex: [0, 0, 0],
            talentMuseum: {
                case_list: [],
            },
            // 新闻
            newsData: {
                top_news: [],
                list: []
            },
            // 学习
            studyMenu: [],
            // 商店
            shopMenu: [],
            // 画廊
            galleryHome: {
                banner: [],
                news: [],
                exhibition: [],
                works: [],
                activity: [],
            },
            galleryAbout: {},
            // 购物车
            shoppingData: [
                {
                    image: '',
                    name: '大苏打阿斯顿阿达a',
                    price: '33.33',
                    total_price: '33.33',
                    length: 1,
                    isShowDelete: false,
                },
            ],
        },
        mutations: {
            talentMenuInit(state, payload) {
                state.talentMenu = payload.map((v, i) => {
                    v.children = v.children.map((item, index) => {
                        let link;
                        switch (item.type) {
                            case 1:
                                // 艺人
                                link = `/talents/star?id=${item.id}`
                                break;
                            
                            case 2:
                                // 博物馆
                                link = `/talents/museum`
                                break;
                            case 3:
                                //艺术家
                                if (item.children.length > 0) {
                                    link = `/talents/artist?id=${item.children[0].id}`
                                    item.children = item.children.map((_item, _index) => {
                                        return {
                                            ..._item,
                                            link: `/talents/artist?id=${_item.id}`
                                        }
                                    })
                                } else {
                                    link = `/talents/artist?id=${item.id}`
                                }
                                break;
                            case 4:
                                // ip
                                link = `/talents/ip?id=${item.id}`
                                break;
                            case 5:
                                // 主题
                                link = `/talents/theme?id=${item.id}`
                                break;
                            default:
                                break;
                        }
                        return {
                            ...item,
                            link
                        }
                    })
                    v.link = v.children[0].link;
                    return v
                })
            },
            setHomeData(state, payload) { 
                // 娱乐商务 移动端
                let entertainmentAll = [];
                payload.entertainment.forEach(v => {
                    entertainmentAll = entertainmentAll.concat(v.image);
                });
                state.homeData.entertainmentAll = entertainmentAll;
                // 艺术授权 移动端
                let art_licensingAll = [];
                payload.art_licensing.forEach(v => {
                    art_licensingAll = art_licensingAll.concat(v.image);
                });
                state.homeData.art_licensingAll = art_licensingAll;
                // 画廊 移动端
                let new_exhibitionAll = [];
                payload.new_exhibition.forEach(v => {
                    let arr = v.image.map(item => {
                        return {
                            ...item,
                            name: v.name,
                            button_name: v.button_name
                        }
                    })
                    new_exhibitionAll = new_exhibitionAll.concat(arr);
                });
                state.homeData.new_exhibitionAll = new_exhibitionAll;
            },
            setAboutData(state, payload) { 
                state.aboutData.bannerMobile = payload.banner.map(v => {
                    return {
                        ...v,
                        name2: v.name
                    }
                })
            },
            // 购物车
            shoppingInit(state, payload) { 
                state.shoppingData = payload.map(v => {
                    return {
                        ...v,
                        // 新增length用于商品数量的显示和修改，count可以在修改失败以后重置length
                        length: v.count,
                        // 新增isShowDelete用于显示‘确认删除’按钮
                        isShowDelete: false,
                    }
                })
            },
        },
        actions: {
            // 获取搜索引擎关键字，描述
            getSeo(content, payload) { 
                axios.get(config.seo, {
                    params: {
                        // lang: localStorage.getItem('lang'),
                        // token: localStorage.getItem('token'),
                    }
                }).then((result) => {
                    if (result.data.code == 100) { 
                        content.state.metaInfo = result.data.data;
                    }
                }).catch((err) => {
                    
                });
            },
            // 首页
            getHome(content, payload) {
                axios.get(config.home, {
                    params: {
                        lang: localStorage.getItem('lang')
                    }
                }).then((result) => {
                    if (result.data.code == 100) {
                        content.state.homeData = result.data.data;
                        content.commit('setHomeData', result.data.data);
                    }
                }).catch((err) => {
                    
                });
            },
            // 关于我们
            getAbout(content, payload) {
                axios.get(config.about, {
                    params: {
                        lang: localStorage.getItem('lang')
                    }
                }).then((result) => {
                    if (result.data.code == 100) {
                        content.state.aboutData = result.data.data;
                        content.commit('setAboutData', result.data.data);
                    }
                }).catch((err) => {

                });
            },
            // 关于我们 - 二级页面
            getAboutMore(content, payload) {
                return new Promise((resolve, reject) => {
                    axios.get(config.aboutMore, {
                        params: {
                            lang: localStorage.getItem('lang'),
                            ...payload,
                        }
                    }).then((result) => {
                        resolve(result.data);
                    }).catch((err) => {
                        reject(err)
                    });
                });
            },
            // 留言
            submitMessage(content, payload) {
                return new Promise((resolve, reject) => {
                    axios.get(config.message, {
                        params: {
                            // lang: localStorage.getItem('lang'),
                            ...payload
                        }
                    }).then((result) => {
                        resolve(result.data);
                    }).catch((err) => {
                        reject(err)
                    });
                });
            },
            // 联系我们
            getContactUs(content, payload) { 
                axios.get(config.contactUs, {
                    params: {
                        lang: localStorage.getItem('lang'),
                    }
                }).then((result) => {
                    if (result.data.code == 100) { 
                        content.state.contactData = result.data.data;
                    }
                }).catch((err) => {
                    
                });
            },
            // 短信验证码
            getCode(content, payload) { 
                return new Promise((resolve, reject) => {
                    axios.get(config.code, {
                        params: {
                            // lang: localStorage.getItem('lang'),
                            ...payload
                        }
                    }).then((result) => {
                        resolve(result.data);
                    }).catch((err) => {
                        reject(err)
                    });
                });
            },
            // 登录
            login(content, payload){
                return new Promise((resolve, reject) => {
                    axios.get(config.login, {
                        params: {
                            // lang: localStorage.getItem('lang'),
                            ...payload
                        }
                    }).then((result) => {
                        resolve(result.data);
                    }).catch((err) => {
                        reject(err)
                    });
                });
            },
            // 注册
            reg(content, payload) {
                return new Promise((resolve, reject) => {
                    axios.get(config.reg, {
                        params: {
                            // lang: localStorage.getItem('lang'),
                            ...payload
                        }
                    }).then((result) => {
                        resolve(result.data);
                    }).catch((err) => {
                        reject(err)
                    });
                });
            },
            // 获取用户信息
            getUserinfo(content, payload) { 
                axios.get(config.getUserinfo, {
                    params: {
                        // lang: localStorage.getItem('lang'),
                        token: localStorage.getItem('token'),
                    }
                }).then((result) => {
                    if (result.data.code == 100) { 
                        content.state.isLogin = true;
                        content.state.userinfo = result.data.userinfo;
                    } else {
                        localStorage.removeItem('token');
                    }
                }).catch((err) => {
                    
                });
            },
            // 人才-菜单
            getTalentMenu(content, payload) {
                axios.get(config.talentMenu, {
                    params: {
                        lang: localStorage.getItem('lang'),
                    }
                }).then((result) => {
                    if (result.data.code == 100) {
                        // content.state.talentMenu = result.data.data;
                        content.commit('talentMenuInit', result.data.data);
                    }
                }).catch((err) => {
                    
                });
            },
            // 人才-艺人列表|艺术家列表
            getTalentList(content, payload) {
                return new Promise((resolve, reject) => {
                    axios.get(config.talentList, {
                        params: {
                            lang: localStorage.getItem('lang'),
                            ...payload
                        }
                    }).then((result) => {
                        resolve(result.data);
                    }).catch((err) => {
                        reject(err)
                    });
                });
            },
            // 人才-艺术家图片组|主题详情
            getTalentImages(content, payload) {
                return new Promise((resolve, reject) => {
                    axios.get(config.talentImages, {
                        params: {
                            lang: localStorage.getItem('lang'),
                            ...payload
                        }
                    }).then((result) => {
                        resolve(result.data);
                    }).catch((err) => {
                        reject(err)
                    });
                });
            },
            // 人才-形象ip详情
            getTalentIp(content, payload) {
                return new Promise((resolve, reject) => {
                    axios.get(config.talentIp, {
                        params: {
                            lang: localStorage.getItem('lang'),
                            ...payload
                        }
                    }).then((result) => {
                        resolve(result.data);
                    }).catch((err) => {
                        reject(err)
                    });
                });
            },
            // 人才 - 博物馆
            getTalentMuseum(content, payload) {
                axios.get(config.talentMuseum, {
                    params: {
                        lang: localStorage.getItem('lang'),
                    }
                }).then((result) => {
                    if (result.data.code == 100) {
                        content.state.talentMuseum = result.data.data;
                    }
                }).catch((err) => {
                    
                });
            },
            // 新闻 - 列表
            getNewsData(content, payload) {
                return new Promise((resolve, reject) => {
                    axios.get(config.news, {
                        params: {
                            lang: localStorage.getItem('lang'),
                        }
                    }).then((result) => {
                        resolve(result.data);
                        if (result.data.code == 100) {
                            content.state.newsData = result.data.data;
                        }
                    }).catch((err) => {
                        reject(err)
                    });
                });
            },
            // 新闻 - 详情
            getNewsDetail(content, payload) {
                return new Promise((resolve, reject) => {
                    axios.get(config.newsDetail, {
                        params: {
                            lang: localStorage.getItem('lang'),
                            ...payload
                        }
                    }).then((result) => {
                        resolve(result.data);
                    }).catch((err) => {
                        reject(err)
                    });
                });
            },
            // 学习 - 菜单
            getStudyMenu(content, payload) {
                axios.get(config.studyMenu, {
                    params: {
                        lang: localStorage.getItem('lang'),
                    }
                }).then((result) => {
                    if (result.data.code == 100) {
                        content.state.studyMenu = result.data.data;
                    }
                }).catch((err) => {
                    
                });
            },
            // 学习 - 列表
            getStudyList(content, payload) {
                return new Promise((resolve, reject) => {
                    axios.get(config.studyList, {
                        params: {
                            lang: localStorage.getItem('lang'),
                            ...payload
                        }
                    }).then((result) => {
                        resolve(result.data);
                    }).catch((err) => {
                        reject(err)
                    });
                });
            },
            // 学习 - 详情
            getStudyDetail(content, payload) {
                return new Promise((resolve, reject) => {
                    axios.get(config.studyDetail, {
                        params: {
                            lang: localStorage.getItem('lang'),
                            ...payload
                        }
                    }).then((result) => {
                        resolve(result.data);
                    }).catch((err) => {
                        reject(err)
                    });
                });
            },
            // 商店 - 菜单
            getShopMenu(content, payload) {
                axios.get(config.shopMenu, {
                    params: {
                        lang: localStorage.getItem('lang'),
                    }
                }).then((result) => {
                    if (result.data.code == 100) {
                        content.state.shopMenu = result.data.data;
                    }
                }).catch((err) => {
                    
                });
            },
            // 商店 - 首页|一级页面
            getShopHome(content, payload) {
                return new Promise((resolve, reject) => {
                    axios.get(config.shopHome, {
                        params: {
                            lang: localStorage.getItem('lang'),
                            ...payload
                        }
                    }).then((result) => {
                        resolve(result.data);
                    }).catch((err) => {
                        reject(err)
                    });
                });
            },
            //商店 - 筛选
            getShopFilter(content, payload) {
                return new Promise((resolve, reject) => {
                    axios.get(config.shopFilter, {
                        params: {
                            lang: localStorage.getItem('lang'),
                            ...payload
                        }
                    }).then((result) => {
                        resolve(result.data);
                    }).catch((err) => {
                        reject(err)
                    });
                });
            },
            //商店 - 详情
            getShopDetail(content, payload) {
                return new Promise((resolve, reject) => {
                    axios.get(config.shopDetail, {
                        params: {
                            lang: localStorage.getItem('lang'),
                            ...payload
                        }
                    }).then((result) => {
                        resolve(result.data);
                    }).catch((err) => {
                        reject(err)
                    });
                });
            },
            // 商店 - 新增购物车
            addCart(content, payload) { 
                return new Promise((resolve, reject) => {
                    axios.get(config.shopAddCart, {
                        params: {
                            // lang: localStorage.getItem('lang'),
                            token: localStorage.getItem('token'),
                            ...payload
                        }
                    }).then((result) => {
                        resolve(result.data);
                    }).catch((err) => {
                        reject(err)
                    });
                });
            },
            // 商店 - 购物车列表
            getShopCart(content, payload) { 
                return new Promise((resolve, reject) => {
                    axios.get(config.shopCartList, {
                        params: {
                            lang: localStorage.getItem('lang'),
                            token: localStorage.getItem('token'),
                            // ...payload
                        }
                    }).then((result) => {
                        content.commit('shoppingInit', result.data.data);
                        resolve(result.data);
                    }).catch((err) => {
                        reject(err)
                    });
                });
            },
            // 商店 - 修改购物车数量
            setShopCartCount(content, payload) { 
                return new Promise((resolve, reject) => {
                    axios.get(config.shopCartCount, {
                        params: {
                            // lang: localStorage.getItem('lang'),
                            token: localStorage.getItem('token'),
                            ...payload
                        }
                    }).then((result) => {
                        resolve(result.data);
                    }).catch((err) => {
                        reject(err)
                    });
                });
            },
            // 商店 - 删除
            deleteShopCart(content, payload) { 
                return new Promise((resolve, reject) => {
                    axios.get(config.shopCartDelete, {
                        params: {
                            // lang: localStorage.getItem('lang'),
                            token: localStorage.getItem('token'),
                            ...payload
                        }
                    }).then((result) => {
                        resolve(result.data);
                    }).catch((err) => {
                        reject(err)
                    });
                });
            },
            // 画廊 - 首页
            getGalleryHome(content, payload) {
                axios.get(config.galleryHome, {
                    params: {
                        lang: localStorage.getItem('lang'),
                    }
                }).then((result) => {
                    if (result.data.code == 100) {
                        content.state.galleryHome = result.data.data;
                    }
                }).catch((err) => {
                    
                });
            },
            // 画廊 - 关于我们
            getGalleryAbout(content, payload) {
                axios.get(config.galleryAbout, {
                    params: {
                        lang: localStorage.getItem('lang'),
                    }
                }).then((result) => {
                    if (result.data.code == 100) {
                        content.state.galleryAbout = result.data.data;
                    }
                }).catch((err) => {
                    
                });
            },
            // 画廊 - 展览筛选
            getGalleryCategory(content, payload) {
                return new Promise((resolve, reject) => {
                    axios.get(config.galleryCategory, {
                        params: {
                            lang: localStorage.getItem('lang'),
                            ...payload
                        }
                    }).then((result) => {
                        resolve(result.data);
                    }).catch((err) => {
                        reject(err)
                    });
                });
            },
            // 画廊 - 展览列表
            getGalleryList(content, payload) {
                return new Promise((resolve, reject) => {
                    axios.get(config.galleryList, {
                        params: {
                            lang: localStorage.getItem('lang'),
                            ...payload
                        }
                    }).then((result) => {
                        resolve(result.data);
                    }).catch((err) => {
                        reject(err)
                    });
                });
            },
            // 画廊 - 展览详情
            getGalleryDetail(content, payload) { 
                return new Promise((resolve, reject) => {
                    axios.get(config.galleryDetail, {
                        params: {
                            lang: localStorage.getItem('lang'),
                            ...payload
                        }
                    }).then((result) => {
                        resolve(result.data);
                    }).catch((err) => {
                        reject(err)
                    });
                });
            },
            // 画廊 - 艺术家列表
            getGalleryArtist(content, payload) { 
                return new Promise((resolve, reject) => {
                    axios.get(config.galleryArtist, {
                        params: {
                            lang: localStorage.getItem('lang'),
                            ...payload
                        }
                    }).then((result) => {
                        resolve(result.data);
                    }).catch((err) => {
                        reject(err)
                    });
                });
            },
            // 画廊 - 艺术家详情
            getGalleryArtistDetail(content, payload) { 
                return new Promise((resolve, reject) => {
                    axios.get(config.galleryArtistDetail, {
                        params: {
                            lang: localStorage.getItem('lang'),
                            ...payload
                        }
                    }).then((result) => {
                        resolve(result.data);
                    }).catch((err) => {
                        reject(err)
                    });
                });
            },
            // 画廊 - 作评列表
            getGalleryWorks(content, payload) { 
                return new Promise((resolve, reject) => {
                    axios.get(config.galleryWorks, {
                        params: {
                            lang: localStorage.getItem('lang'),
                            ...payload
                        }
                    }).then((result) => {
                        resolve(result.data);
                    }).catch((err) => {
                        reject(err)
                    });
                });
            },
            // 画廊 - 作评详情
            getGalleryWorksDetail(content, payload) { 
                return new Promise((resolve, reject) => {
                    axios.get(config.galleryWorksDetail, {
                        params: {
                            lang: localStorage.getItem('lang'),
                            ...payload
                        }
                    }).then((result) => {
                        resolve(result.data);
                    }).catch((err) => {
                        reject(err)
                    });
                });
            },
            // 画廊 - 画展预约
            joinExhibition(content, payload) { 
                return new Promise((resolve, reject) => {
                    axios.get(config.galleryExhibitionJoin, {
                        params: {
                            // lang: localStorage.getItem('lang'),
                            token: localStorage.getItem('token'),
                            ...payload
                        }
                    }).then((result) => {
                        resolve(result.data);
                    }).catch((err) => {
                        reject(err)
                    });
                });
            },
            // 上传图片
            upImages(content, payload) {
                return new Promise((resolve, reject) => { 
                    axios.post(config.upImage, payload, {
                        headers: { 'Content-Type': 'multipart/form-data' },
                    }).then((result) => {
                        if (result.data.code == 100) { 
                            resolve(result.data);
                        } else {
                            reject();
                        }
                    }).catch((err) => {
                        reject();
                    });
                });
            },
        }
    })
}